// src/pages/Tickets/TicketClientAnswers.jsx
// -----------------------------------------------------------------------------
// Shows the answers given to the project's client-facing questions when the
// ticket was raised (Requirement #18). Renders nothing if there are none.
// -----------------------------------------------------------------------------
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ticketService from '../../api/ticketService';
import clientQuestionService from '../../api/clientQuestionService';

export default function TicketClientAnswers({ ticketID }) {
  const [answers, setAnswers] = useState([]);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    ticketService.getClientAnswers(ticketID).then((res) => setAnswers(res.data || [])).catch(() => {});
    clientQuestionService.getAll().then((res) => setQuestions(res.data || [])).catch(() => {});
  }, [ticketID]);

  if (answers.length === 0) return null;

  const questionText = (id) =>
    questions.find((q) => Number(q.questionID) === Number(id))?.questionText || `Question #${id}`;

  return (
    <div className="card" style={{ marginBottom: 20 }}>
      <div className="sidebar-panel-title">Client Questions</div>
      {answers.map((a) => (
        <div key={a.answerID} style={{ marginBottom: 10 }}>
          <strong>{questionText(a.questionID)}</strong>
          <p style={{ whiteSpace: 'pre-wrap', margin: '4px 0 0' }}>{a.answerText}</p>
        </div>
      ))}
    </div>
  );
}

TicketClientAnswers.propTypes = {
  ticketID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
